import { createFileRoute } from '@tanstack/react-router';
import { LogListCard } from '@/features/logs/LogCards';

export const Route = createFileRoute('/a/logs/')({
  staticData: {
    breadcrumbs: [{ label: 'Logs' }],
  },
  component: AdminLogListPage,
});

function AdminLogListPage() {
  return <LogListCard restaurantId={null} />;
}
